import { useQuery } from '@tanstack/react-query';

import { venueListShopifyStoreProductsApi } from '../../../api/shopify/venueListShopifyStoreProductsApi';
import { VenueListShopifyStoreProductsFilter } from '../../../graphql/API';

export const useVenueListShopifyStoreProductsQuery = (
  filters: VenueListShopifyStoreProductsFilter,
) => {
  const { data, isFetching, isError, isLoading } = useQuery({
    queryKey: ['shopify-product-list', { ...filters }],
    queryFn: async ({ queryKey }) => {
      const [, filters] = queryKey as [string, VenueListShopifyStoreProductsFilter];

      return venueListShopifyStoreProductsApi(filters);
    },
    refetchOnWindowFocus: false,
    enabled: !!filters.venueID,
  });
  return { data, isFetching, isError, isLoading };
};
